<template>
    <login-form></login-form>
</template>

<script>
import LoginForm from '@commons/LoginForm.vue'

export default{
    components:{
        LoginForm
    }
}

</script>



// WEBPACK FOOTER //
// Login.vue?1333b0e0